import { render } from "./ManageOrder.vue?vue&type=template&id=31278e19&scoped=true"
import script from "./ManageOrder.vue?vue&type=script&lang=js"
export * from "./ManageOrder.vue?vue&type=script&lang=js"

import "./ManageOrder.vue?vue&type=style&index=0&id=31278e19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31278e19"]])

export default __exports__